import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Inventory_ModuleContextService } from './Inventory.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Inventory_materials_by_licenseplate_dd_ComponentContextService {
  private readonly moduleContext: Inventory_ModuleContextService;

  constructor(moduleContext: Inventory_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'materials_by_licenseplate_dd',
      type: ComponentType.selector
    }
  }
}